import script from "./login_info.vue?vue&type=script&lang=ts&setup=true"
export * from "./login_info.vue?vue&type=script&lang=ts&setup=true"

import "./login_info.vue?vue&type=style&index=0&id=63ea51fa&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63ea51fa"]])

export default __exports__